import { ADMIN_FLASH } from '../../constants/actions';
import { LOCATION_CHANGE } from 'react-router-redux';

const initialState = {
    message: '',
    flashType: null
};

function reducer(state = initialState, action) {
    switch (action.type) {
        case ADMIN_FLASH.OPEN:
            return { ...state, message: action.message, flashType: action.flashType || 'success' };
        case ADMIN_FLASH.CLOSE:
        case LOCATION_CHANGE:
            return initialState;
        default:
            return state;
    }
}

export default reducer;
